import { SmallBox } from '@app/components';
import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ContentHeader, Loader } from '@components';
import { getAllProjects } from '../../services/project';
import { getAllDocumentation } from '@app/services/docs';


const AllDocs = () => {
  const [projects, setProjects] = React.useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [projectFilesCount,setProjectFilesCount] = useState([])


  const getAllProjectsFn = async () => {
    setShowLoader(true)
    const res = await getAllProjects();
    const result = await getAllDocumentation();

    if (res.data.ok) {
      setProjects(res.data.data);
    }
    if(result.data.ok)
    {
      setProjectFilesCount(result.data.data)
    }

    setShowLoader(false)
  }


  React.useEffect(() => {
    getAllProjectsFn();
  }, []);

  return (
    <React.Fragment>
      <ContentHeader title="Documentation" />
      {showLoader ? <Loader title={"Daily"} /> : (
        <section className="content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">All Documentation</h3>
              </div>
              <div className="card-body">
                <div className="container-fluid">
                  <div className="card">
                    <div className="card-header d-flex align-items-baseline justify-content-between">
                      <h3 className="card-title card-width">All Documentation</h3>
                      <div className="input-group input-width input-group-lg offset-md-2 right">
                        <input type="search" className="form-control form-control-lg" placeholder="Type your keywords" />
                        <div className="input-group-append">
                          <button type="submit" className="btn btn-lg btn-default">
                            <i className="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-12 col-lg-12 order-2 order-md-1">
                        <div className="row">
                          { projects.map(project => (
                            <div className="col-12 col-sm-4">
                              <div className="info-box bg-light">
                                <div className="info-box-content text-capitalize">
                                  <Link to={"/view-project/" + project._id}>
                                    <span className="info-box-number text-center text-muted">{project.projectName}</span>
                                    <span className="info-box-text text-center text-muted mb-0">3 Folder</span>
                                    <span className="info-box-text text-center text-muted mb-0">10 Files</span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ))}


                        </div>

                        <div className="card-pagination">
                          <ul className="pagination pagination-sm justify-content-center">
                            <li className="page-item"><a className="page-link" href="#">«</a></li>
                            <li className="page-item"><a className="page-link" href="#">1</a></li>
                            <li className="page-item"><a className="page-link" href="#">2</a></li>
                            <li className="page-item"><a className="page-link" href="#">3</a></li>
                            <li className="page-item"><a className="page-link" href="#">»</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </React.Fragment>
  )
}

export default AllDocs;